import {useQuery} from "@tanstack/react-query";
import {getMe} from "../services/AuthService";
import {useParams} from "react-router-dom";
import {technicianApi, userApi} from "../services/technicianService";
import {clientApi} from "../services/clientService";
import {getStoredAuthToken} from "../utils/authToken";

export const useMe = () => {
  const token = getStoredAuthToken();
  const {data, isLoading, isError, error, refetch} = useQuery({
    queryKey: ["getMe"],
    queryFn: () => getMe(token),
    enabled: Boolean(token),
    select: (data) => data.data,
  });

  return {
    data: data?.data,
    isLoading,
    isError,
    error,
    refetch,
  };
};

export const useTechnician = () => {
  const {id: idUrl} = useParams();
  const id = idUrl.split("-")[0];
  const {data, isLoading, isError, error, refetch} = useQuery({
    queryKey: ["Technician", id],
    queryFn: () => technicianApi.getOne({id}),
    select: (data) => data,
  });

  return {
    data,
    isLoading,
    isError,
    error,
    refetch,
  };
};
export const useBlockedUsers = () => {
  const {data, isLoading, isError, error} = useQuery({
    queryKey: ["blocked"],
    queryFn: () => userApi.listBlocked(),
    select: (data) => data.rows,
  });
  return {
    data,
    isLoading,
    isError,
    error,
  };
};

export const useClient = () => {
  const {id: idUrl} = useParams();
  const id = idUrl.split("-")[0];
  const {data, isLoading, isError, error, refetch} = useQuery({
    queryKey: ["Client", id],
    queryFn: () => clientApi.getOne({id}),
    select: (data) => data,
  });

  return {
    data,
    isLoading,
    isError,
    error,
    refetch,
  };
};
